

var pdfMake;
async function getPdfMake() {
    if (!pdfMake) pdfMake = await import('pdfmake').then(({ default: pdfMake }) => pdfMake);
    return pdfMake;
}

export default function ArtworkPdf(artworks, logoUrl, statusCb) {
    return buildPdfData(artworks, logoUrl, {text: statusCb}).then(createPdf)
}

function getDataUri(url) {
    return new Promise(function (resolve /*, reject */) {
        var image = new Image();
        image.crossOrigin = "anonymous";

        image.onload = function () {
            var canvas = document.createElement('canvas');
            canvas.width = this.naturalWidth; // or 'width' if you want a special/scaled size
            canvas.height = this.naturalHeight; // or 'height' if you want a special/scaled size

            canvas.getContext('2d').drawImage(this, 0, 0);

            // Get raw image data
            // .replace(/^data:image\/(png|jpg);base64,/, '')
            resolve({
                img: canvas.toDataURL('image/png'),
                h: this.naturalHeight,
                w: this.naturalWidth
            });
        };

        image.src = url;
    });
}

function artworkPdfContent(artwork, i) {
    return getDataUri(i > 20 ? artwork.thumbnail : artwork.fullImage) // filepath_full
        .then(function (imgData) {
            var details = [
                (artwork.height || '?'),
                'x',
                (artwork.width || '?'),
                // '|',
                // (artwork.year || '?')
            ].join(' ');
            if (artwork.medium) details += "\n" + artwork.medium;
            if (artwork.availability) details += "\n" + artwork.availability;
            // el.find('.width').text(artwork.w || '?');
            // el.find('.year').text(artwork.year || '?');
            // el.find('.medium').text(artwork.medium || '');
            // el.find('.price').text(artwork.availability || '');

            //imgData.h;
            var columnGap = 9;
            var pageSize = 612 - (columnGap * 2);
            var columnNum = 3;
            var actualHSize = pageSize - (columnGap * (columnNum - 1));
            // var width = actualHSize / columnNum;

            // var ratio = imgData.h / imgData.w;
            // var calculatedHeight = width * ratio;
            // if (calculatedHeight > 350) {
            //   var ratio2 = imgData.h / 350;
            //   width = width / ratio2;
            // }

            var WIDTH = actualHSize / columnNum;

            var imgContent = {
                image: imgData.img,
                //width: width,
                //fit: [WIDTH, WIDTH],
                alignment: 'center'
            };

            //if (i <= 20) {
                imgContent.fit = [WIDTH, WIDTH];
            //}

            var inner = [];
            inner.push(imgContent);
            if (artwork.artist) inner.push({ text: artwork.artist.name, alignment: 'center', fontSize: 10, margin: [0, 4, 0, 0]});
            inner.push({ text: artwork.title, alignment: 'center', bold: true });
            inner.push({ text: details, alignment: 'center', fontSize: 8, margin: [0, 0, 0, 9] })

            var content = [{
                margin: [0, 0, 0, 0],
                layout: 'noBorders',
                alignment: 'center',
                table: {
                    dontBreakRows: true,
                    widths: ['*'],
                    body: [
                        [inner]
                    ]
                }
            }];

            return { artwork: artwork, content: content, imgData: imgData };
        });
}

var _getFonts;
function getFonts() {
    _getFonts = _getFonts || fetch('/lato-light.json').then(response => response.json());
    return _getFonts;
}

function buildPdfData(artworks, logoUrl, statusDiv) {
    var logo = getDataUri(logoUrl).then(function (uri) { return { logo: uri } });
    var promises = artworks.map(artworkPdfContent).concat(logo).concat(getFonts());
    var numDone = 0;
    statusDiv.text('downloaded ' + numDone + ' of ' + promises.length, numDone, promises.length);

    promises = promises.map(function (promise) {
        return promise.then(function (v) {
            numDone++;
            if (numDone == promises.length) {
                statusDiv.text('building pdf', numDone, promises.length);
            } else {
                statusDiv.text('downloaded ' + numDone + ' of ' + promises.length, numDone, promises.length);
            }
            return v;
        });
    });
    promises.push(getPdfMake());

    return Promise.all(promises)
        .then(function (results) {
            return results.reduce(function (acc, curr) {
                if (curr.logo) {
                    acc.logo = curr.logo;
                } else if (curr.vfs) {
                    pdfMake.fonts = curr.fonts;
                    pdfMake.vfs = curr.vfs;
                } else {
                    acc.artworks.push(curr);
                }
                return acc;
            }, { artworks: [] })
        })
        .then(function (result) {
            var nids = artworks.map(function (a) { return a.nid });
            result.permaLink = location.origin + '/#favorites-' + nids.sort().join(',');
            return result;
        });
}

function createPdf(content) {
    var docDefinition = {
        // LETTER: [612.00, 792.00],
        pageSize: 'LETTER',
        // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
        pageMargins: [9, 9, 9, 60], // [ 40, 40, 40, 40 ],
        defaultStyle: {
            font: 'Lato'
        },
        info: {
            title: 'Modern Arts Midtown Select Works (' + (new Date()).getTime() + ')',
            author: 'Modern Arts Midtown',
            creator: 'modernartsmidtown.com',
            producer: 'modernartsmidtown.com',
        },
        footer: [
            {
                margin: [9, 0, 9, 0],
                layout: 'noBorders',
                table: {
                    widths: ['*', 50],
                    body: [
                        [
                            {
                                margin: [0, 0, 0, 0],
                                image: content.logo.img,
                                width: content.logo.w / 8,
                                height: content.logo.h / 8
                            },
                            [
                                { qr: content.permaLink, fit: '50', alignment: 'right' },
                                { text: 'link', fontSize: 6, link: content.permaLink, alignment: 'right' }
                            ]
                        ],
                    ],
                },
            },
        ],
        content: [
            {
                columns: splitUp(content.artworks.map(function (a) { return a.content; }), 3),
                columnGap: 9
            },

        ]
    };


    return new Promise(function (resolve /*, reject */) {
        pdfMake.createPdf(docDefinition).download('Modern-Arts-Midtown-Favorite-Works.pdf', resolve);
    });
}

function splitUp(arr, n) {
    var buckets = [];
    arr.forEach(function (el, i) {
        var b = i % n;
        buckets[b] = buckets[b] || [];
        buckets[b].push(el);
    });
    return buckets;
}
